import { NgModule } from '@angular/core';
import { RouterModule, type Routes } from '@angular/router';

import { LoginCallbackComponent } from './components/login-callback/login-callback.component';
import { LogoutComponent } from './components/logout/logout.component';

const routes: Routes = [
  {
    path: 'logout',
    pathMatch: 'full',
    component: LogoutComponent,
  },
  {
    path: 'login/callback',
    pathMatch: 'full',
    component: LoginCallbackComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
